const GetUsers = async () => {
  let response = await fetch(`${process.env.REACT_APP_API_URL}/Users`).catch((error) => {
    console.error("Error fetching data:", error);
  });

  return response.status === 200 ? await response.json() : [];
};
export default GetUsers;
